import { useGenerateReports } from '../../ExcelExportDialog/utils';
import { ExcelExportFormValues } from '../types';

export interface UseExcelExportLogicProps {
  pageType: string | null | undefined;
  firmInfo: any;
  companyInfo: any;
  fundInfo: any;
  currentMeasurementDate: any;
  formValues: ExcelExportFormValues;
  setErrors: (errors: any) => void;
}

export const useExcelExportLogic = ({
  pageType,
  firmInfo,
  companyInfo,
  fundInfo,
  currentMeasurementDate,
  formValues,
  setErrors,
}: UseExcelExportLogicProps) => {
  const { generateReport, generateFirmSummaryReport, generateFundSummaryReport, generateFundInvestmentsReport } = useGenerateReports({
    pageType,
    firmInfo,
    companyInfo,
    fundInfo,
    currentMeasurementDate,
    setErrors,
    formValues,
  });

  return {
    generateReport,
    generateFirmSummaryReport,
    generateFundSummaryReport,
    generateFundInvestmentsReport,
  };
};
